import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "feedback" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Check-In", -1 /* HOISTED */)
const _hoisted_3 = { class: "message1" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Hey ")
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "message2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("It looks like your meeting with ")
const _hoisted_8 = { class: "name" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" was just held. We'd love to hear how it went!")
const _hoisted_10 = { class: "rating-container" }
const _hoisted_11 = { class: "range-slider" }
const _hoisted_12 = { class: "values" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "range1" }, "1", -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "range2" }, "10", -1 /* HOISTED */)
const _hoisted_15 = { class: "slider-container" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "start" }, null, -1 /* HOISTED */)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "slider-track" }, null, -1 /* HOISTED */)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "end" }, null, -1 /* HOISTED */)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "note-feedback" }, "Rate your meeting experience between 1-10", -1 /* HOISTED */)
const _hoisted_20 = { class: "feedback-container-meeting flex-center" }
const _hoisted_21 = { class: "checkbox-container" }
const _hoisted_22 = {
  key: 1,
  class: "description-container"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Leave Additional Feedback", -1 /* HOISTED */)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "btn-container button-container-feedback" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("span", _hoisted_5, _toDisplayString($setup.userName), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("span", _hoisted_8, _toDisplayString($setup.recipientName), 1 /* TEXT */),
      _hoisted_9
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createCommentVNode("Using this as a placeholder for now, creating a similar component soon"),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("span", {
            class: "value",
            style: _normalizeStyle({left: (($setup.sliderValue-1) * 10.388) + '%'})
          }, _toDisplayString($setup.sliderValue), 5 /* TEXT, STYLE */),
          _hoisted_14
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _hoisted_17,
          _withDirectives(_createElementVNode("input", {
            class: "slider",
            type: "range",
            min: 1,
            max: 10,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.sliderValue) = $event)),
            stepVal: "1"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $setup.sliderValue]
          ]),
          _hoisted_18
        ])
      ]),
      _hoisted_19
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        (!$setup.useMessage)
          ? (_openBlock(), _createBlock($setup["VCheckbox"], {
              key: 0,
              class: "checkbox",
              modelValue: $setup.useMessage,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.useMessage) = $event))
            }, null, 8 /* PROPS */, ["modelValue"]))
          : _createCommentVNode("v-if", true),
        (!$setup.useMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
          : _createCommentVNode("v-if", true)
      ]),
      ($setup.useMessage)
        ? (_openBlock(), _createBlock($setup["TextField"], {
            key: 0,
            class: "note",
            label: "Message",
            modelValue: $setup.message,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.message) = $event))
          }, null, 8 /* PROPS */, ["modelValue"]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("button", {
        class: "primary feedback",
        onClick: $setup.sendFeedback
      }, _toDisplayString($props.isPayer ? "Confirm Meeting" : "Send Feedback"), 1 /* TEXT */)
    ])
  ]))
}